import type { ShouldRevalidateFunction } from 'react-router-dom';

const validateOnServiceSuccess: ShouldRevalidateFunction = (args) =>
  args.actionStatus === 302 ||
  args.actionStatus === 204 ||
  args.actionStatus === 200;

const validateOnFormSubmission: ShouldRevalidateFunction = (args) =>
  args.formMethod != null && args.formMethod.toUpperCase() !== 'GET';

export const validateOnServerInteraction: ShouldRevalidateFunction = (args) =>
  validateOnServiceSuccess(args) || validateOnFormSubmission(args);

export const validateChildRouteOnServerInteraction: ShouldRevalidateFunction = (
  args,
) => {
  if (args.currentParams.leadId !== args.nextParams.leadId) {
    return true;
  }
  return validateOnServerInteraction(args);
};
